let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("53bRG")).then(() => parcelRequire('ixF1M'));